import { Dispatch } from 'redux'
import { useDispatch } from 'react-redux'
import Action from 'src/redux/action'
import { Memoized } from './dependencies'

export default useDispatch as () => Memoized<Dispatch<Action>>
